module.exports = __webpack_public_path__ + "img/megafon.904504ec.svg";